// extracted by mini-css-extract-plugin
var _1 = "DragPlaceholderGrid_element__cac9a";
var _2 = "DragPlaceholderGrid_group__76f69";
export { _1 as "element", _2 as "group" }
